import { APP_ENV } from '../environments';
import getBrandConfigByIdentifier from './utils/getBrandConfigByIdentifier';
import { ALL_THEME_CONFIGS, THEME_CONFIG_HOYA, THEME_CONFIG_SEIKO } from './themes';

/***********************************************
 * Branding Constants
 **********************************************/

/**
 * The config of the brand that should be active on the site. This is determined
 * by the site's domain and checking to see if there are any brands configured
 * that contain an identifier found in the domain.
 */
export const ACTIVE_BRAND_CONFIG = getBrandConfigByIdentifier( window.location.origin, APP_ENV );

if ( !ACTIVE_BRAND_CONFIG ) {
    console.warn(
        `Unable to retrieve brand configuration for '${ window.location.origin }' in environment `
        + `'${ APP_ENV }'. Please verify that the desired brand configuration exists in your expected `
        + 'environment and try again.'
    );
}

/**
 * The ID of the brand that should be active on the site.
 */
export const ACTIVE_BRAND_UUID = ACTIVE_BRAND_CONFIG?.id;


/***********************************************
 * Theme Constants
 **********************************************/

/**
 * The config of the theme that should be active on the site. This is determined
 * by the brand that is currently active.
 */
export const ACTIVE_THEME_CONFIG = ALL_THEME_CONFIGS.find( ( config ) => config?.id === ACTIVE_BRAND_CONFIG?.metadata?.themeId );

/**
 * The name or key of the theme to be using on the site. If no branding configuration
 * was found to use on the site, default to the HOYA theme.
 */
export const ACTIVE_THEME_NAME = ( ACTIVE_THEME_CONFIG?.name || THEME_CONFIG_HOYA?.name );

/**
 * Whether or not the site's active theme is HOYA's theme.
 */
export const IS_HOYA_THEME = ( ACTIVE_THEME_NAME === THEME_CONFIG_HOYA?.name );

/**
 * Whether or not the site's active theme is SEIKO's theme.
 */
export const IS_SEIKO_THEME = ( ACTIVE_THEME_NAME === THEME_CONFIG_SEIKO?.name );
